import React from 'react';
import {withRouter} from "react-router";

import {Button} from "reactstrap";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

import APPCONFIG from 'constants/Config';
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import API from "@beardeddevops/react.api";

/**
 *  @property {Accounts_Object} state
 *  @property {object} model
 *  @property {Accounts_Properties} model.properties
 *  @property {Accounts_Is} model.is
 *  @property {Accounts_Has} model.has
 */
class ForgotPassword extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Accounts._name);
		this.model.requestType = API.RequestType.READ;
		this.brand = APPCONFIG.brand;
	}

	handleSubmit = async event => {
		if (typeof event !== 'undefined') event.preventDefault();

		this.setState({loading: true});
		if (this.handleProcess()) {
			await this.model.submit(this, API.RequestType.READ);
			this.props.history.push('/login');
		} else {
			this.setState({loading: false});
		}
		return false;
	};

	render() {
		let {properties} = this.model;
		let object = this.state;
		let brand = this.brand;
		return (
			<div className="body-inner">
				<Card>
					<CardContent style={{paddingBottom: 0}}>
						<section className="logo text-center">
							<h1>{brand}</h1>
						</section>
							<fieldset>
								<div className="form-group">
									<Framework.Elements.TextField
										value={object.email}
										error={object.email_error}
										property={properties.email}
										update={this.handleTextFieldPropertyUpdate}
										variant={"standard"}
									/>
									<div className="additional-info text-center text-small">
										Enter your email address that you used to register. We'll send you an email with
										your username and a link to reset your password.
									</div>
								</div>
							</fieldset>
					</CardContent>
					<CardActions>
						<Button onClick={() => this.props.history.push('/login')} color="secondary" size={"md"} block={false}>Back to Login</Button>
						<Button color="primary" size={"md"} block={false}>Reset</Button>
					</CardActions>
				</Card>
			</div>
		);
	}
}

const ForgotPasswordRoute = withRouter(ForgotPassword);
const Page = () => (
	<div className="page-forgot">
		<div className="main-body">
			<div key="1">
				<ForgotPasswordRoute/>
			</div>
		</div>
	</div>
);

export default Page;
